import mediator from "@tvg/mediator";
import { BetaFeature } from "./types";
import { GTM_BETA_PROGRAM } from "./types/gtm";

export const gtmViewOnboardingModal = (betaFeature: BetaFeature) =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.ONBOARDING_VIEW,
    payload: {
      betaFeature
    }
  });

export const gtmClickCTAOnboardingModal = (buttonText: string | undefined) =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.ONBOARD_CTA,
    payload: {
      eventLabel: buttonText || ""
    }
  });

export const gtmViewExitModal = () =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.EXIT_VIEW
  });

export const gtmClickCTAExitModal = (buttonText: string) =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.EXIT_CTA,
    payload: {
      eventLabel: buttonText
    }
  });

export const gtmViewLearnMoreModal = () =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.LEARN_MORE_VIEW
  });

export const gtmClickCTALearnMoreModal = (buttonText: string | undefined) =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.LEARN_MORE_CTA,
    payload: {
      eventLabel: buttonText || ""
    }
  });

export const gtmOpenFeedbackWidget = () =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.FEEDBACK_OPEN
  });

export const gtmSubmitFeedbackWidget = () =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.FEEDBACK_SUBMIT
  });

export const gtmAccountPanelNavigationLink = (
  linkText: string,
  destinationUrl: string
) =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.ACCOUNT_PANEL_LINK,
    payload: {
      eventLabel: linkText,
      destinationUrl
    }
  });

export const gtmViewWelcomeModal = (betaFeature: BetaFeature) =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.WELCOME_VIEW,
    payload: {
      betaFeature
    }
  });

export const gtmClickCTALetsStartModal = () =>
  mediator.base.dispatch({
    type: GTM_BETA_PROGRAM.LETS_START_CTA
  });
